/* istanbul ignore file */
// NOTE Exposes all the CSS custom properties as typed objects
import accent from '@/core/tamagoshiv2/tokens/colors/_accent.module.scss';
import brand from '@/core/tamagoshiv2/tokens/colors/_brand.module.scss';
import copper from '@/core/tamagoshiv2/tokens/colors/_copper.module.scss';
import error from '@/core/tamagoshiv2/tokens/colors/_error.module.scss';
import foundation from '@/core/tamagoshiv2/tokens/colors/_foundation.module.scss';
import gold from '@/core/tamagoshiv2/tokens/colors/_gold.module.scss';
import info from '@/core/tamagoshiv2/tokens/colors/_info.module.scss';
import misc from '@/core/tamagoshiv2/tokens/colors/_misc.module.scss';
import promotion from '@/core/tamagoshiv2/tokens/colors/_promotion.module.scss';
import secondLife from '@/core/tamagoshiv2/tokens/colors/_secondLife.module.scss';
import silver from '@/core/tamagoshiv2/tokens/colors/_silver.module.scss';
import success from '@/core/tamagoshiv2/tokens/colors/_success.module.scss';
import sustainable from '@/core/tamagoshiv2/tokens/colors/_sustainable.module.scss';
import warning from '@/core/tamagoshiv2/tokens/colors/_warning.module.scss';
import radius from '@/core/tamagoshiv2/tokens/radius/_radius.module.scss';
import shadows from '@/core/tamagoshiv2/tokens/shadows/_shadows.module.scss';
import spacings from '@/core/tamagoshiv2/tokens/spacings/_spacings.module.scss';

const colors = {
  accent,
  brand,
  copper,
  error,
  foundation,
  gold,
  info,
  misc,
  promotion,
  secondLife,
  silver,
  success,
  sustainable,
  warning,
} as const;

export { colors, radius, shadows, spacings };
